import { useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useClientAuth } from '../../auth/ClientAuthContext';
import API_BASE from '../../utils/api';
import '../../styles/AuthForm.css';

export default function ClientAcceptInvite() {
  const { clientId } = useParams();
  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { clientLogin } = useClientAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/client/auth/accept-invite`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, inviteToken, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data?.error || 'Failed to activate account. The link may have expired.');
        return;
      }

      clientLogin(data);
      navigate('/client/dashboard', { replace: true });
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  if (!clientId || !inviteToken) {
    return (
      <div className="auth-form">
        <img src="/logo.png" alt="InteriorFolio Logo" className="auth-logo" />
        <div className="auth-card">
          <h2>Invalid Link</h2>
          <p className="auth-subtitle">This invite link is invalid. Please check your email.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-form">
      <img src="/logo.png" alt="InteriorFolio Logo" className="auth-logo" />

      <form className="auth-card" onSubmit={handleSubmit}>
        <h2>Set Up Your Account</h2>
        <p className="auth-subtitle">Choose a password to access your client portal.</p>

        <input
          type="password"
          placeholder="Password (at least 8 characters)"
          value={password}
          onChange={(e) => { setPassword(e.target.value); if (error) setError(''); }}
          aria-invalid={Boolean(error)}
          required
          autoComplete="new-password"
        />

        <input
          type="password"
          placeholder="Confirm password"
          value={confirm}
          onChange={(e) => { setConfirm(e.target.value); if (error) setError(''); }}
          aria-invalid={Boolean(error)}
          required
          autoComplete="new-password"
        />

        {error && (
          <div className="auth-error-banner" role="alert" aria-live="polite">
            <strong>Oops.</strong> {error}
          </div>
        )}

        <button type="submit" disabled={loading}>
          {loading ? 'Activating…' : 'Activate Account'}
        </button>
      </form>
    </div>
  );
}
